import Papa from 'papaparse';
import { genders } from 'constants/campaign';
import { DiscoveredCreator } from 'types/creator-discovery';
import { getSocialAccountProfileURL } from 'utils/helpers';

const COLUMNS = [
    'name',
    'handle',
    'url',
    'engagement_score',
    'followers_count',
    'average_views',
    'mobile',
    'gender',
    'age_bucket',
] as const;

const COLUMN_LABELS: Record<(typeof COLUMNS)[number], string> = {
    name: 'Name',
    handle: 'Handle',
    url: 'URL',
    engagement_score: 'Engagement Score',
    followers_count: 'Followers',
    average_views: 'Average Views',
    mobile: 'Mobile',
    gender: 'Gender',
    age_bucket: 'Age',
};

const creatorToCsvRow = (creator: DiscoveredCreator): Record<string, string | number> => {
    const genderKey = creator.ig?.gender;
    const gender = genderKey ? (genders[genderKey as keyof typeof genders] ?? genderKey) : '';

    return {
        name: creator.name ?? '',
        handle: creator.handle ?? '',
        url: getSocialAccountProfileURL(creator.handle, creator.platform),
        engagement_score: creator.engagement_score ?? '',
        followers_count: creator.followers_count ?? '',
        average_views: creator.average_views ?? '',
        mobile: creator.mobile ?? '',
        gender,
        age_bucket: creator.ig?.age_bucket ?? '',
    };
};

export const buildDiscoveredCreatorsCsv = (creators: DiscoveredCreator[]): string => {
    const columnLabels = COLUMNS.map((column) => COLUMN_LABELS[column]);
    const rows = creators.map((creator) => {
        const row = creatorToCsvRow(creator);
        return COLUMNS.map((column) => row[column] ?? '');
    });

    return Papa.unparse({ fields: columnLabels, data: rows });
};


export const downloadCsvFile = (csv: string, filename: string) => {
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
};
